import { render, staticRenderFns } from "./ProductPlan.vue?vue&type=template&id=18bcdd6a&scoped=true&"
import script from "./ProductPlan.vue?vue&type=script&lang=js&"
export * from "./ProductPlan.vue?vue&type=script&lang=js&"
import style0 from "./ProductPlan.vue?vue&type=style&index=0&id=18bcdd6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bcdd6a",
  null
  
)

export default component.exports